import React from 'react'
import { CATEGORY_LIST } from '../urls'
import { useLoad } from '../hooks/request'
import { useModal } from '../hooks/modal'
import CategoryCreate from '../components/CategoryCreate'
import Layout from '../components/Layout'
import SettingsTabs from '../components/settings/SettingsTabs'
import Card from '../components/common/Card'
import Button from '../components/common/Button'
import Table from '../components/common/Table'
import CategoryItem from '../components/CategoryItem'

export default function Currency() {
    const categories = useLoad({ url: CATEGORY_LIST })

    const [showCreateModal, hideCreateModal] = useModal(
        <CategoryCreate onSuccess={() => {
            hideCreateModal()
            categories.request()
        }} onCancel={() => hideCreateModal()} />,
    )
    return (
        <Layout className="has-background-light">
            <SettingsTabs />

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <Card>
                    <div className="columns">
                        <div className="is-size-4 column">Категория</div>

                        <div className="column is-narrow">
                            <Button
                                onClick={showCreateModal}
                                text="Добавить"
                                icon="add-outline"
                                className="is-pulled-right is-link is-outlined" />
                        </div>
                    </div>

                    <Table
                        loading={categories.loading}
                        items={categories.response ? categories.response.results : []}
                        renderItem={(item, index) => (
                            <CategoryItem
                                index={index}
                                categories={categories}
                                item={item}
                                key={item.id}
                                onDelete={categories.request}
                                onUpdate={categories.request}
                                status={categories}
                            />
                        )} />

                </Card> <br />
            </div>
        </Layout>
    )
}
